import { render } from "./SentView.vue?vue&type=template&id=7c433c25"
import script from "./SentView.vue?vue&type=script&lang=js"
export * from "./SentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__